<script setup>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faComment, faClock, faFolder } from "@fortawesome/free-regular-svg-icons"
import { faTag } from "@fortawesome/free-solid-svg-icons"

library.add(faComment, faClock, faFolder, faTag)

const props = defineProps({ 
  articlesData : Array
})
</script>

<template>
  <ul>
    <li v-for="thread in props.articlesData" :key="thread.tid">
      <a :href="thread.url">
        <div class="css__text-left" style="font-size: 1.1em;">{{ thread.title }}</div>
        <div class="css__text-left" style="margin: .6em 0;">
          <!-- カテゴリ -->
          <span style="margin: 0 0 0 .5em; padding: .3em .5em; font-size: .8em; background: #dddddd; border-radius: 0.3em;">
            <font-awesome-icon icon="fa-regular fa-folder" size="lg" />
            {{ thread.category.name }}
          </span>
          <!-- タグ -->
          <span v-for="tags in thread.tags" :key="tags.id" style="margin: 0 0 0 .5em; padding: .3em .5em; font-size: .8em; background: #dddddd; border-radius: 0.3em;">
            <font-awesome-icon icon="fa-solid fa-tag" size="lg" />
            {{ tags.name }}
          </span>
        </div>

        <div class="css__flex-between">
          <span style="margin: 0; font-size: .85em;">
          <font-awesome-icon icon="fa-regular fa-clock" size="lg" />
          {{ thread.cre_dt }}
          </span>
          <span style="font-size: .85em;">
            <font-awesome-icon icon="fa-regular fa-comment" size="lg" />
            {{ thread.count }}
          </span>
        </div>
      </a>
    </li>
  </ul>
</template>

<style scoped>
  ul {
    list-style: none;
    padding: 1em .2em;
    margin: 0;
  }

  li {
    padding: 0;
    display: inline-block;
    position: relative;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
  }

  li a {
    display: block;
    margin: 0;
    padding: 1.25em .75em;
    color: #383c3c;
    text-decoration: none;
  }

  li a:hover {
    transition: .3s;
    background: rgba(0, 0, 0, .05);
  }

  li:first-child {
    border-top: 1px solid rgba(0, 0, 0, .05);
  }

  li span {
    margin-right: .5em;
  }

  li.css__li-child {
    padding-left: 1em;
    border-left: .4em solid rgba(0, 0, 0, .05);
  }
</style>